import React from 'react';
import * as classes from './category.module.css';
import { Link } from 'gatsby';

export default function Category({ categories }) {
  return (
    <div className={classes.container}>
      <div className={classes.items}>
        <div className={classes.topMenu_container}>
          <ul className={classes.menu_list}>
            {categories.map((category) => (
              <li key={category.name} className={classes.menu_item}>
                <Link
                  to={category.uri}
                  activeClassName={classes.selected_menu}
                  className={classes.menu_name}
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
